var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudCheckAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4C10.9155 4 12.9674 5.55718 13.7064 7.72247C14.3558 7.26719 15.1467 7 16 7C18.2091 7 20 8.79086 20 11C20 11.2443 19.9781 11.4836 19.9361 11.7158C21.1779 12.5168 22 13.9124 22 15.5C22 17.9853 19.9853 20 17.5 20H6.5C4.01472 20 2 17.9853 2 15.5C2 14.1098 2.63045 12.8668 3.62104 12.0413C3.22431 11.2812 3 10.4168 3 9.5C3 6.46243 5.46243 4 8.5 4ZM16.5303 10.5303C16.8232 10.2374 16.8232 9.76256 16.5303 9.46967C16.2374 9.17678 15.7626 9.17678 15.4697 9.46967L10 14.9393L7.53033 12.4697C7.23744 12.1768 6.76256 12.1768 6.46967 12.4697C6.17678 12.7626 6.17678 13.2374 6.46967 13.5303L9.46967 16.5303C9.76256 16.8232 10.2374 16.8232 10.5303 16.5303L16.5303 10.5303Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudCheckAlt);
export default __webpack_public_path__ + "static/media/cloud-check-alt.1ce2408489d0243ae65cec01427c8ed5.svg";
export { ForwardRef as ReactComponent };